import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  scrollPosition: 0,
  isScrolling: false,
  visibleSections: [],
  animationsEnabled: true,
  reducedMotion: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setScrollPosition: (state, action) => {
      state.scrollPosition = action.payload;
    },
    setIsScrolling: (state, action) => {
      state.isScrolling = action.payload;
    },
    addVisibleSection: (state, action) => {
      if (!state.visibleSections.includes(action.payload)) {
        state.visibleSections.push(action.payload);
      }
    },
    setAnimationsEnabled: (state, action) => {
      state.animationsEnabled = action.payload;
    },
    setReducedMotion: (state, action) => {
      state.reducedMotion = action.payload;
    },
  },
});

export const {
  setScrollPosition,
  setIsScrolling,
  addVisibleSection,
  setAnimationsEnabled,
  setReducedMotion,
} = uiSlice.actions;

export default uiSlice.reducer;

